export const pagesEquipmentEn = {
  title: "Equipment",
  list: {
    pageTitle: "Equipment",
    addEquipment: "Add Equipment",
    filterPlaceholder: "Search equipment...",
    tabs: {
      all: "All",
      disposed: "Disposed",
      pendingDisposal: "Pending Disposal",
    },
    table: {
      headers: {
        equipment: "Equipment",
        equipmentType: "Type",
        model: "Model",
        serialNumber: "Serial Number",
        assetTag: "Asset Management Number/Asset Tag",
        assignedPerson: "Assigned Person",
        assignedPlace: "Assigned Place",
        createdAt: "Created At",
      },
    },
    filters: {
      equipmentType: "Equipment Type",
      equipmentItem: "Equipment Item",
      assignedWorker: "Assigned Worker",
      placementPlace: "Placement Place",
    },

    csv: {
      headers: {
        id: "ID",
        name: "Name",
        equipmentType: "Type",
        model: "Model",
        serialNumber: "Serial Number",
        assetTag: "Asset Tag",
        assignedPerson: "Assigned Person",
        assignedPlace: "Assigned Place",
        createdAt: "Created At",
      },
    },
  },
  add: {
    pageTitle: "Add Equipment",
    title: "Add Equipment",
    stepper: {
      basic: "Basic Information",
      identification: "Identification",
      assignment: "Assignment",
      placement: "Placement",
      other: "Other",
      lifecycle: "Operations & Maintenance",
      maintenance: "Failure & Repair",
    },
    progressbar: {
      title: "Progress",
      fieldsCompleted: "Completed",
      fieldsTotal: "Total",
      total: "All Fields",
      mustItem: "Required Fields",
      left: "{{value}} fields remaining",
      filled: "Completed",
      modeSetting: "Input Mode",
      mustItemOnly: "Required fields only",
    },
    step1: {
      title: "Basic Information",
      description: "Enter basic information about the equipment",
      name: {
        label: "Equipment Name",
        placeholder: "e.g., MacBook Pro 13-inch",
      },
      equipmentType: {
        label: "Equipment Type",
        placeholder: "Select equipment type",
      },
      equipmentTypeName: {
        label: "Equipment Type",
        placeholder: "Select equipment type",
      },
      equipmentItem: {
        label: "Equipment Item",
        placeholder: "Select equipment item",
      },
      equipmentItemName: {
        label: "Equipment Item",
        placeholder: "Select equipment item",
      },
      isManagementTarget: {
        label: "Subject to equipment management",
      },
      isControlTarget: {
        label: "Subject to Equipment Management",
      },
      controlType: {
        label: "Management Method",
        options: {
          inventoryManagement: "Inventory Management",
          distributionLogManagement: "Distribution Log Management",
          unmanaged: "Unmanaged",
        },
      },
      unit: {
        label: "Equipment Unit",
      },
      mustOnly: {
        label: "Enter required fields only",
      },
      purchaseDate: {
        label: "Purchase Date",
      },
      unitPrice: {
        label: "Equipment Unit Price",
        placeholder: "e.g., 150000",
      },
      unitPriceCurrency: {
        label: "Currency",
      },
      supplier: {
        label: "Supplier",
        placeholder: "e.g., Apple Store",
      },
      remarks: {
        label: "Remarks",
        placeholder: "Enter remarks",
      },
      purchaseMethod: {
        label: "Purchase Method",
        placeholder: "Select purchase method",
      },
      purchaseRequestNumber: {
        label: "Purchase Request Number",
        placeholder: "e.g., PUR-2024-001",
      },
      nextButton: "Next: Identification",
    },
    step2: {
      title: "Identification",
      inventoryId: {
        label: "Equipment/Consumable Management ID",
        placeholder: "e.g., INV-2024-001",
      },
      manufacturer: {
        label: "Manufacturing Company",
        placeholder: "e.g., Apple",
      },
      productName: {
        label: "Product Name/Model Name",
        placeholder: "e.g., MacBook Pro",
      },
      modelNumber: {
        label: "Model Number",
        placeholder: "e.g., A2338",
      },
      serialNumber: {
        label: "Serial Number",
        placeholder: "e.g., C02XX1234567",
      },
      assetTag: {
        label: "Asset Management Number / Asset Tag",
        placeholder: "e.g., AS-2024-001",
      },
      manufactureDate: {
        label: "Manufacture Date",
      },
      controlType: {
        label: "Control Type",
        placeholder: "Select control type",
        options: {
          INVENTORY_MANAGEMENT: "Inventory Management",
          DISTRIBUTION_LOG_MANAGEMENT: "Distribution Log Management",
          UNMANAGED: "Unmanaged",
        },
      },
      nextButton: "Next: Assignment",
    },
    step3: {
      title: "Assignment Information",
      skipInfo: 'If there is no assignee, click "Skip"',
      assignedWorker: {
        label: "Lending/User Name",
        placeholder: "Select lending/user name",
      },
      assignmentStartDate: {
        label: "Assignment Start Date",
      },
      expectedReturnDate: {
        label: "Expected Lending End Date",
      },
      usageAgreementSigned: {
        label: "Usage Agreement Signed",
      },
      usageStatus: {
        label: "Usage/Lending Status",
        placeholder: "Select usage/lending status",
        options: {
          inUse: "In Use",
          returned: "Returned",
          disposed: "Disposed",
          underRepair: "Under Repair",
          reserved: "Reserved",
          stored: "Stored",
        },
      },
      usageType: {
        label: "Usage Type",
        placeholder: "Select usage type",
        options: {
          personalLoan: "Personal Loan",
          sharedUse: "Shared Use",
          shortTermLoan: "Short-term Loan",
          homeUse: "Home Use",
        },
      },
      usagePlace: {
        label: "Usage Location",
        placeholder: "Select usage location",
      },
      usageRestrictions: {
        label: "Usage Restrictions",
        placeholder: "Enter any usage restrictions",
      },
      nextButton: "Next: Placement",
      skipButton: "Skip",
    },
    step4: {
      title: "Placement Information",
      skipInfo: 'If there is no placement location, click "Skip"',
      place: {
        label: "Installation Location",
        placeholder: "Select installation location",
        searchPlaceholder: "Search by location name",
      },
      placementType: {
        label: "Installation Type",
        placeholder: "Select installation type",
        options: {
          fixed: "Fixed",
          free: "Free",
          inStorage: "In Storage",
          mobile: "Mobile",
        },
      },
      placementDate: {
        label: "Installation Date",
      },
      areaName: {
        label: "Area Name",
        placeholder: "e.g., Meeting Room A",
      },
      deskSeatNumber: {
        label: "Seat Number/Desk Number",
        placeholder: "e.g., D-101",
      },
      reasonForPlacement: {
        label: "Reason for Installation",
        placeholder: "Enter reason for installation",
      },
      labelStickerNo: {
        label: "Equipment Sticker Number",
        placeholder: "e.g., LS-2024-001",
      },
      placementDetails: {
        title: "Placement Details",
      },
      gpsOrBleTagNo: {
        label: "GPS/BLE Tag ID",
        placeholder: "e.g., TAG-2024-001",
      },
      placementDocumentLink: {
        label: "Placement Document Link",
        placeholder: "e.g., https://example.com/doc",
      },
      placementNotes: {
        label: "Placement Notes",
        placeholder: "Enter notes about the placement",
      },
      placementStatus: {
        label: "Current Placement Status",
        placeholder: "Select placement status",
        options: {
          inUse: "In Use",
          stored: "Stored",
          moving: "Moving",
          toBeDisposed: "To Be Disposed",
          notPlaced: "Not Placed",
        },
      },
      lastPhysicalCheckDate: {
        label: "Last Physical Check Date",
      },
      verificationMethod: {
        label: "Verification Method",
        placeholder: "Select verification method",
        options: {
          physicalCheck: "Physical Check",
          scan: "Scan",
          photoRecord: "Photo Record",
        },
      },
      placementVerificationStatus: {
        label: "Placement Verification Status",
        placeholder: "Select verification status",
        options: {
          ok: "OK",
          mismatch: "Mismatch",
          unverified: "Unverified",
        },
      },
      shelfCabinetNumber: {
        label: "Shelf/Cabinet Number",
        placeholder: "e.g., S-A-01",
      },
      physicalEnvironment: {
        label: "Physical Environment",
        placeholder: "Enter dimensions, environmental conditions, etc.",
      },
      nextButton: "Next: Operations & Maintenance",
      skipButton: "Skip",
    },
    step5: {
      title: "Operations & Maintenance",
      purchase: {
        title: "Purchase & Introduction",
        description:
          "Enter information about the equipment purchase and introduction",
        assetId: "Asset ID (Management Number)",
        assetIdPlaceholder: "e.g., AST-2024-001",
        purchaseDate: "Purchase Date",
        purchaseDatePlaceholder: "Select purchase date",
        vendorSupplierName: "Vendor/Supplier Name",
        vendorPlaceholder: "e.g., Apple Store",
        purchaseCost: "Purchase Cost",
        purchaseCostPlaceholder: "e.g., 150000",
        warrantyStartDate: "Warranty Start Date",
        warrantyStartPlaceholder: "Select warranty start date",
        warrantyExpiryDate: "Warranty Expiry Date",
        warrantyExpiryPlaceholder: "Select warranty expiry date",
        maintenanceContractId: "Maintenance Contract ID",
        maintenanceContractPlaceholder: "e.g., MC-2024-001",
      },
      operation: {
        title: "Operation & Usage",
        description: "Enter information about the equipment operation status",
        usageStartDate: "Usage Start Date",
        usageStartPlaceholder: "Select usage start date",
        plannedReturnDate: "Planned Return Date",
        plannedReturnPlaceholder: "Select planned return date",
        operationalStatus: "Operational Status",
        statusPlaceholder: "Select operational status",
        operationalStatusOptions: {
          active: "Active",
          stopped: "Stopped",
          onLoan: "On Loan",
        },
      },
      nextButton: "Next: Failure & Repair",
    },
    step6: {
      title: "Failure & Repair",
      failure: {
        title: "Failure Information",
        description: "Enter information if any failure has occurred",
        incidentFailureId: "Incident/Failure ID",
        incidentIdPlaceholder: "e.g., INC-2024-001",
        failureDate: "Failure Date",
        failureDatePlaceholder: "Select failure date",
        failureDescription: "Failure Content/Symptoms",
        failureDescPlaceholder:
          "Please describe the failure symptoms in detail",
      },
      repair: {
        title: "Repair Information",
        description: "Enter information about repair response",
        repairRequestDate: "Repair Request Date",
        requestDatePlaceholder: "Select repair request date",
        repairCompletedDate: "Repair Completed Date",
        completedDatePlaceholder: "Select repair completed date",
        technicianVendor: "Technician/Vendor",
        technicianPlaceholder: "e.g., Apple Support",
        repairCost: "Repair Cost",
        repairCostPlaceholder: "e.g., 30000",
        maintenanceNotes: "Maintenance Notes",
        notesPlaceholder: "Enter any maintenance notes or precautions",
      },
      summary: {
        title: "Registration Details",
        name: "Equipment Name",
        assignedTo: "Assigned To",
        place: "Placement Location",
        assetId: "Asset ID",
      },
      submitButton: "Register",
      submitting: "Registering...",
      submitError: "Registration failed. Please try again.",
      inputError: "There are errors in your input. Please check each step.",
      submitSuccess: "Equipment registered (ID: {{equipmentId}})",
    },
    workerSearch: {
      placeholder: "Search for worker",
    },
    validation: {
      nameRequired: "Equipment name is required",
      equipmentTypeRequired: "Equipment type is required",
      equipmentItemRequired: "Equipment item is required",
      controlTypeRequired: "Management method is required",
      assignmentStartDateRequired: "Assignment start date is required",
      returnDateInvalid:
        "Expected lending end date must be after lending start date",
    },
  },
  settings: {
    shared: {
      actionsColumn: {
        disableButton: "Disable",
        enableButton: "Enable",
        deleteButton: "Delete",
      },
      DeleteDialog: {
        title: 'Delete "{{name}}"?',
        description:
          'If "{{name}}" is in use, the master name cannot be deleted. This operation cannot be undone.',
        cancelButton: "Cancel",
        permanentlyDeleteButton: "Permanently Delete",
      },
    },
    equipmentTypes: {
      title: "Equipment Types",
      description: "Manage equipment categories",
      addEquipmentType: "Add Equipment Type",
      editEquipmentType: "Edit {{name}}",
      searchPlaceholder: "Search equipment types...",
      showDeactivated: "Show disabled items",
      form: {
        name: {
          label: "Name",
          placeholder: "",
        },
        category: {
          label: "Category",
          placeholder: "Select category",
        },
        displayOrder: {
          label: "Display Order",
          description:
            "If no display order is entered, the default value 0 will be set.",
          placeholder: "1",
        },
        description: {
          label: "Description",
          description: "Enter a description for this equipment type.",
          placeholder: "Purpose and features of this equipment type",
        },
      },
      table: {
        name: "Type Name",
        category: "Category",
        description: "Description",
        displayOrder: "Display Order",
      },
      disableDialog: {
        title: "Disable Item",
        description: 'Are you sure you want to disable "{{name}}"?',
        cancel: "Cancel",
        confirm: "Disable",
        success: {
          title: "Item Disabled",
          description: '"{{name}}" has been disabled.',
        },
        error: {
          title: "Error",
          description: "Failed to disable the item.",
        },
      },
      enableDialog: {
        title: "Enable Item",
        description: 'Are you sure you want to enable "{{name}}"?',
        cancel: "Cancel",
        confirm: "Enable",
        success: {
          title: "Item Enabled",
          description: '"{{name}}" has been enabled.',
        },
        error: {
          title: "Error",
          description: "Failed to enable the item.",
        },
      },
      categories: {
        OFFICE_FURNITURE: "Office Furniture",
        TOOLS_MEASURING_EQUIPMENT: "Tools & Measuring Equipment",
        RESEARCH_LABORATORY_EQUIPMENT: "Research & Lab Equipment",
        EXHIBITION_DEMO_EQUIPMENT: "Exhibition & Demo Equipment",
        PERIPHERAL_DEVICES: "PC Peripherals",
        CONFERENCE_EQUIPMENT: "Conference Room Equipment",
        CONSUMABLES: "Consumables",
        PERSONAL_OFFICE_EQUIPMENT: "Personal Office Equipment",
        OTHER: "Other",
      },
    },
    equipmentItems: {
      title: "Equipment Items",
      description: "Manage equipment subcategories",
      addEquipmentItem: "Add Equipment Item",
      editEquipmentItem: "Edit {{name}}",
      editPresetEquipmentItem: "Edit {{name}} (Preset)",
      searchPlaceholder: "Search equipment items...",
      showDeactivated: "Show disabled items",
      form: {
        name: {
          label: "Name",
          placeholder: "",
        },
        equipmentType: {
          label: "Equipment Type",
          placeholder: "Select type",
        },
        displayOrder: {
          label: "Display Order",
          description:
            "If no display order is entered, the default value 0 will be set.",
          placeholder: "1",
        },
        description: {
          label: "Description",
          description: "Enter a description for this equipment item.",
          placeholder: "Purpose and features of this equipment item",
        },
        workerAvailability: {
          label: "Member Availability Options",
          description:
            "By selecting whether items can be provided or loaned to members, they can be managed in various business packages in the General Affairs Core.",
        },
        isProvidable: {
          label: "Can be Provided",
        },
        isLoanable: {
          label: "Can be Loaned",
        },
      },
      table: {
        name: "Item Name",
        equipmentType: "Equipment Type",
        description: "Description",
        isProvidable: "Providable",
        isLoanable: "Loanable",
        displayOrder: "Display Order",
      },
      disableDialog: {
        title: "Disable Item",
        description: 'Are you sure you want to disable "{{name}}"?',
        cancel: "Cancel",
        confirm: "Disable",
        success: {
          title: "Item Disabled",
          description: '"{{name}}" has been disabled.',
        },
        error: {
          title: "Error",
          description: "Failed to disable the item.",
        },
      },
      enableDialog: {
        title: "Enable Item",
        description: 'Are you sure you want to enable "{{name}}"?',
        cancel: "Cancel",
        confirm: "Enable",
        success: {
          title: "Item Enabled",
          description: '"{{name}}" has been enabled.',
        },
        error: {
          title: "Error",
          description: "Failed to enable the item.",
        },
      },
    },
  },
  detail: {
    pageTitle: "Equipment Details",
    sections: {
      equipmentIdInfo: "ID Information",
      equipmentAssignment: "Assignment",
      equipmentPlacement: "Placement",
      equipmentPlacementStatus: "Placement Status",
      equipmentPlacementDetail: "Placement Detail",
      procurementAcquisition: "Procurement/Acquisition",
      usageOperation: "Usage/Operation",
      maintenanceRepair: "Maintenance/Repair",
      retirementDisposal: "Retirement/Disposal",
    },
    fields: {
      equipmentId: "Equipment ID",
      inventoryId: "Equipment/Consumable Management ID",
      equipmentName: "Equipment Name",
      equipmentType: "Equipment Type",
      equipmentItem: "Equipment Item",
      serialNumber: "Serial Number",
      assetTag: "Asset Tag",
      unitPrice: "Unit Price",
      unitPriceCurrency: "Currency",
      unit: "Equipment Unit",
      manufacturer: "Manufacturing Company",
      productName: "Product Name/Model Name",
      modelNumber: "Model Number",
      manufactureDate: "Manufacture Date",
      controlType: "Control Type",
      isControlTarget: "Is Control Target",
      assignmentStartDate: "Assignment Start Date",
      expectedReturnDate: "Expected Lending End Date",
      currentAssignment: "Current Assignment",
      noAssignment: "No assignment",
      addAssignment: "Add Assignment",
      selectPerson: "Select Person",
      assignedWorkerId: "Assigned Worker ID",
      registeredByWorkerId: "Registered By",
      actualReturnDate: "Actual Return Date",
      usageStatus: "Usage Status",
      usageType: "Usage Type",
      usageLocation: "Usage Location",
      usageAgreementSigned: "Usage Agreement Signed",
      usageRestrictions: "Usage Restrictions",
      equipmentRelationType: "Equipment Relation Type",
      usageResponsiblePerson: "Usage Responsible Person",
      placementPlaceId: "Placement Place",
      placementType: "Installation Type",
      placementPlace: "Installation Location",
      placementDate: "Installation Date",
      placementLocationName: "Location Name",
      placementBuildingName: "Building Name",
      placementFloorNumber: "Floor Number",
      placementAreaName: "Area Name",
      deskSeatNumber: "Seat Number/Desk Number",
      reasonForPlacement: "Installation Reason",
      equipmentStickerNumber: "Equipment Sticker Number",
      gpsOrBleTagNo: "GPS/BLE Tag ID",
      gpsOrBleTagId: "GPS/BLE Tag ID",
      placementDocumentLink: "Installation Related Documents",
      placementNotes: "Placement Notes",
      placementRemarks: "Placement Remarks",
      placementStatus: "Current Placement Status",
      lastPhysicalCheckDate: "On-site Verification Date",
      placementVerificationMethod: "Placement Verification Method",
      placementVerificationStatus: "Placement Verification Status",
      placementLastUpdated: "Last Updated Date",
      shelfCabinetNumber: "Shelf/Storage Cabinet Number",
      physicalEnvironment: "Installation Location Dimensions/Conditions",
      placementPhotoUrl: "Placement Photo URL",
      assetManagementNumber: "Asset Management Number",
      purchaseDate: "Purchase Date",
      purchaseVendor: "Purchase Source/Vendor Name",
      purchasePrice: "Purchase Price",
      warrantyStartDate: "Warranty Start Date",
      warrantyExpiryDate: "Warranty Expiry Date",
      maintenanceContractId: "Maintenance Contract ID",
      usageStartDate: "Usage Start Date",
      plannedReturnDate: "Planned Return Date",
      operationalStatus: "Operational Status",
      maintenanceId: "Maintenance ID",
      failureOccurredDate: "Failure Occurred Date",
      failureDetails: "Failure Content/Symptoms",
      repairRequestedDate: "Repair Requested Date",
      repairCompletedDate: "Repair Completed Date",
      technicianVendor: "Repair Responsible Worker",
      repairCost: "Repair Cost",
      maintenanceNotes: "Maintenance Notes",
      replacementEquipmentId: "Replacement Equipment ID",
      noMaintenanceHistory: "No maintenance history",
      maintenanceHistory: "Maintenance History",
      disposalDecisionDate: "Disposal Assessment Date",
      disposalMethod: "Disposal Method",
      disposalDate: "Disposal Date",
      wipeMethod: "Data Erasure Method",
      disposalCertificateAttached: "Disposal Certificate Attached",
      accountingDeregistrationDate: "Deregistration Processing Date",
      assetWriteOffReason: "Deregistration Reason",
      remarks: "Remarks",
    },
    options: {
      controlType: {
        INVENTORY_MANAGEMENT: "Inventory Management",
        DISTRIBUTION_LOG_MANAGEMENT: "Distribution Log Management",
        UNMANAGED: "Unmanaged",
      },
      boolean: {
        yes: "Yes",
        no: "No",
      },
      usageStatus: {
        IN_USE: "In Use",
        RETURNED: "Returned",
        UNDER_REPAIR: "Under Repair",
        DISPOSED: "Disposed",
        STORED: "Stored",
        SCHEDULED_FOR_LENDING: "Scheduled for Lending",
      },
      usageType: {
        PERSONAL_ASSIGNMENT: "Personal Assignment",
        SHARED_USE: "Shared Use",
        SHORT_TERM_LENDING: "Short-term Lending",
        WORK_FROM_HOME: "Work from Home",
      },
      placementType: {
        STORED: "Stored",
        FIXED: "Fixed",
        FREE: "Free",
        MOVING: "Moving",
      },
      placementStatus: {
        IN_USE: "In Use",
        STORED: "Stored",
        MOVING: "Moving",
        TO_BE_DISPOSED: "To Be Disposed",
        NOT_PLACED: "Not Placed",
      },
      placementVerificationStatus: {
        OK: "OK",
        MISMATCH: "Mismatch",
        UNVERIFIED: "Unverified",
      },
      verificationMethod: {
        PHYSICAL_CHECK: "Physical Check",
        SCAN: "Scan",
        PHOTO_RECORD: "Photo Record",
      },
      verificationStatus: {
        verified: "Verified",
        pending: "Pending",
        unverified: "Unverified",
      },
      operationalStatus: {
        ACTIVE: "Active",
        STOPPED: "Stopped",
        ON_LOAN: "On Loan",
      },
      disposalMethod: {
        RECYCLING: "Recycling",
        PHYSICAL_DESTRUCTION: "Physical Destruction",
        VENDOR_REQUEST: "Vendor Request",
      },
      wipeMethod: {
        PHYSICAL_DESTRUCTION: "Physical Destruction",
        DOD_STANDARD: "DOD Standard",
        ENCRYPTION_DELETION: "Encryption Deletion",
      },
    },
    actions: {
      removeAssignment: "Remove Assignment",
      addMaintenanceRecord: "Add Maintenance Record",
    },
    messages: {
      maintenanceHistoryCount: "{{count}} maintenance records",
    },
  },
  addSelect: {
    header: {
      headerTitle: "Add Equipment & Consumables",
    },
    body: {
      selectEquipmentType: "Select what you want to add",
      equipmentAndConsumables: "Equipment & Consumables",
      itemCard: {
        requiredDetails: "Required fields",
        equipmentName: "Equipment & Consumables Name",
        equipmentType: "Equipment Type",
        equipmentItem: "Equipment Item",
      },
      fillOutDetails: "Fill out details",
    },
    options: {
      description: "Or...",
      syncIT: "Sync with External System",
      bulkCsvUpload: {
        title: "Bulk upload via CSV",
        description:
          "You can add data for multiple equipment, up to 500 records at a time. A CSV file following the DRESS CODE format is required.",
        selectedEquipmentType: "Selected type:",
        button: "Upload CSV",
      },
    },
  },
  importCsv: {
    title: "Equipment CSV Import",
    unit: "items",
    prepareCsvFile: {
      templateTitle: "Equipment Template",
      updateExisting: "Update existing data",
    },
    completeDialog: {
      button: "Go to Equipment List",
    },
    checkValidColumn: {
      errors: "Errors",
    },
  },
};
